import loadable from "@loadable/component";

const Referral = loadable(() => import("./Referral.page"));

export default { component: Referral };
